import { all, call, fork, put, select, takeLatest } from 'redux-saga/effects';

import {
  UPDATE_LOAN_DETAIL_START,
} from '../../actions/types'

import {
  updateLoanDetailSuccess,
  updateLoanDetailFailure,
} from '../../actions'

import { updateLoanApplication } from '../../requesters/loanApplication'

import {
  getLoanApplicationId,
  getLoanDetailParams,
   } from '../../reducers'

function* loanUpdateLoanDetail(action) {
  const loanDetail = yield select(getLoanDetailParams);
  const loanApplicationId = yield select(getLoanApplicationId);

  const data = {
    application_form_in_progress: {
      loan_detail_attributes: loanDetail
    }
  }

  const { response, error } = yield call(updateLoanApplication, loanApplicationId, data)

  if (response) {
    yield put(updateLoanDetailSuccess(response))
  } else {
    yield put(updateLoanDetailFailure({
      loanDetail: error.response.data.loanDetail,
    }))
  }
}

export function* watchLoanUpdateLoanDetail() {
  yield takeLatest(UPDATE_LOAN_DETAIL_START, loanUpdateLoanDetail)
}
